import React from 'react'
import PropTypes from 'prop-types'

import {
  DialogButtonGroup,
  Callout,
} from '~/components/blueprint'
import {
  Checkbox
} from '@blueprintjs/core'

class EditDialog extends React.Component {
  constructor(props){
    super(props)
    this.handleSave = this.handleSave.bind(this)
    this.togglePms = this.togglePms.bind(this)
    this.handlePmsMode = this.handlePmsMode.bind(this)
    this.handleNumberChange = this.handleNumberChange.bind(this)
    let model = JSON.parse(JSON.stringify(props.model))
    this.state = {
      model,
      pmsMode: model.room_number?'fixed':'manually',
      error: null,
    }
  }
  handleSave(){
    let { model, pmsMode } = this.state
    let { room_number } = model
    if (pmsMode === 'fixed' && room_number === null){
      this.setState({
        error: {
          message: 'Room number required'
        }
      })
    } else {
      this.props.onSave(this.state.model)
    }
  }
  togglePms({target}){
    let { checked } = target
    this.setState((state)=>{
      state.model.to_pms_enabled = checked
      state.error = null
      return state
    })
  }
  handlePmsMode({target}){
    this.setState({
      pmsMode: target.value,
      error: null,
    })
  }
  handleNumberChange({target}){
    let {value} = target
    if (value === ''){
      this.setState(state=>{
        state.model.room_number = null
        state.error = null
        return state
      })
    } else {
      this.setState(state=>{
        state.model.room_number = value
        state.error = null
        return state
      })
    }
  }
  render(){
    let { onCancel } = this.props
    let { model, pmsMode, error } = this.state
    let { to_pms_enabled, room_number } = model
    return (
      <div className="bp-dialog">
        <div className="line">
          Payment Name
        </div>
        <div className="line">
          {this.props.model.name}
        </div>
        <div className="line">
          <Checkbox checked={to_pms_enabled} label="Post to Room" name="to_pms_enabled" onChange={this.togglePms}/>
        </div>
        <div className="line" style={{paddingLeft: 26}}>
          <div className="pt-select">
            <select disabled={!to_pms_enabled} onChange={this.handlePmsMode} value={pmsMode}>
              <option value="manually">Manually</option>
              <option value="fixed">Fixed Room Number</option>
            </select>
          </div>
        </div>
        {pmsMode === 'fixed'?(
          <div className="line" style={{paddingLeft:26}}>
            <input className="pt-input" placeholder="N/A" value={room_number===null?"":room_number} onChange={this.handleNumberChange}/>
          </div>
        ):null}
        {error?<Callout error={error}/>:null}
        <DialogButtonGroup onSave={this.handleSave} onCancel={onCancel} />
      </div>
    )
  }
}

EditDialog.propTypes = {
  model: PropTypes.object,
  onSave: PropTypes.func,
  onCancel: PropTypes.func,
}

export default EditDialog



/** WEBPACK FOOTER **
 ** ./client/pages/settings/pms/EditDialog.js
 **/